import { FHA_FEATURE, CROP_WATER_FEATURE } from '../constants/features';

/**
 * @param {Array.<string>} entities Product Assets features
 * @returns {Boolean}
 */
export function hasFHA(entities = []) {
  return entities.includes(FHA_FEATURE);
}

/**
 * @param {Array.<string>} entities Product Assets features
 * @returns {Boolean}
 */
export function hasCropWaterUse(entities = []) {
  return entities.includes(CROP_WATER_FEATURE);
}
